module.exports = __webpack_public_path__ + "img/pagemakerpro-logo-light.68a45d05.png";